module.exports = __webpack_public_path__ + "static/media/flag-ta.c0e8fe8b.webp";